<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary" icon="eye">
         
        </a-button>

        <a-modal width="1000px" v-model="visible" title="  مشاهده درخواست" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>
<template>
  <a-card title="اطلاعات درخواست ">
    <a-card-grid style="width: 20%; text-align: center">توضیحات</a-card-grid>
    <a-card-grid style="width: 20%; text-align: center">وضعیت</a-card-grid>
    <a-card-grid style="width: 20%; text-align: center">حساب</a-card-grid>
    <a-card-grid style="width: 20%; text-align: center">مقدار</a-card-grid>
    <a-card-grid style="width: 20%; text-align: center">کاربر</a-card-grid>
    <a-card-grid style="width: 20%; text-align: center">{{ info.description }}</a-card-grid>
    <a-card-grid style="width: 20%; text-align: center">{{ info.status }}</a-card-grid>
    <a-card-grid style="width: 20%; text-align: center">{{ info.account }}</a-card-grid>
    <a-card-grid style="width: 20%; text-align: center">{{ $root.number_format(info.amount) }}</a-card-grid>
    <a-card-grid style="width: 20%; text-align: center">{{info.user ?  $root.full_name(info . user . firstname , info . user . lastname) : '' }}</a-card-grid>
  </a-card>
</template>
            <form @submit.prevent="addData($event)"  v-show="$root.hasPermission('/financials/list/')" >
            <div class="row text-right mt-md-5">
                        					<h6>    تغییر وضعیت درخواست</h6>
                                            <hr/>
                                             <div class="col-md-8 my-1"></div>

                 <div class="col-md-4 my-1">
                                <label class="sr-only" for="inline-form-input-name"> وضعیت درخواست</label>
                                <select v-model="info.status" class="form-control" name="status">
                                    <option value="">انتخاب</option>
                                    <option value="pending"> درانتظار</option>
                                    <option value="success">قبول شده</option>
                                    <option value="denied">رد شده </option>
                                </select>
                            </div>
                 <div class="col-md-1 my-1">
                    <button :disabled="loading" type="submit" class="btn btn-fill btn-outline-success ">
                        ذخیره
                    </button>
                </div>
            </div>
            </form>
        </a-modal>
    </div>
</template>
<script>

    export default {
        props: {
            info: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,                
            };
        },
        methods: {
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                this.loading = true;
                let url=`/endurance/status/${this.info.id}`
                axios
                    .post(url, data)
                    .then(function(response) {
                        console.log(response)
                        _this.loading = false;
                        _this.$toast.success("  درخواست با موفقیت ویرایش شد");
                    })
                    .catch(function(err) {
                        _this.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
      this.$emit('getData')
            },
        }
    };
</script>
